import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {environment} from "../../../environments/environment";
import {DynamicScriptLoaderServiceService} from "../../_services/dynamic-script-loader-service.service";
import {AuthenicationService} from "../../_services/authenication.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DoctorService} from "../../_services/doctor.service";
import {PatientsService} from "../../_services/patients.service";
import {ToasterService} from "../../_services/toaster.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
  selector: 'app-transfer-patient',
  templateUrl: './transfer-patient.component.html',
  styleUrls: ['./transfer-patient.component.css']
})
export class TransferPatientComponent implements OnInit {

  transferPatientForm: FormGroup;

  userdetaild: string;
  submitted = false;
  baseUrl: string = environment.baseUrl;

  id: string;
  returnUrl: string;
  appointments: any[] = [];
  doctors: any[] = [];
  patientdoctors: any[] = [];
  total: any[] = [];

  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder,private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private doctorservice: DoctorService, private patientsservice: PatientsService ,private toaster: ToasterService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();

    this.id = this.route.snapshot.params.id;


    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    this.transferPatientForm = this.formBuilder.group({
      from_docid: [''],
      to_docid: [''],
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    let payload = {
      clientId: this.id
    }

    this.getPatientDoctorsList(payload);


    let podtData = {status: true};

    this.doctorsList(podtData);


  }


  get f() { return this.transferPatientForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.transferPatientForm.invalid) {
      this.spinnerService.hide();
      return;
    }
    const payload = {
      from_docid: this.transferPatientForm.controls.from_docid.value,
      user_id: this.id,
      to_docid: this.transferPatientForm.controls.to_docid.value
    };

    this.transferPatient(payload);


  }


  transferPatient(payload) {
    this.doctorservice.transferPatient(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.submitted = false;
            this.toaster.showSuccess('Transfer', data.ResponseMessage);
          }else{
            this.toaster.showWarning('Transfer', data.ResponseMessage);
          }
        },
        error => {
          this.submitted = false;
          this.toaster.showError('Transfer', error);
        });
  }

  getPatientDoctorsList(payload) {
    this.doctorservice.getPatientDoctorsList(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let docData = data.Data;
            for (let item of docData) {
                if(this.patientdoctors.indexOf(item) == -1){
                    this.patientdoctors.push(item);
                }
            }
          }else{
            console.log('Transfer', data.ResponseMessage);
          }
        },
        error => {

          console.log('Transfer', error);
        });
  }


  doctorsList(data) {
    this.doctorservice.getDoctorsByStatus(data)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            data.doctorsList.forEach( (item, index) => {
              if(item.docid._id === this.id) data.doctorsList.splice(index,1);
            });
            this.doctors = data.doctorsList;
          } else {
            this.toaster.showError('Doctor', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Doctor', error.ResponseMessage);
        });
  }

}
